<p *ngIf="!isBusinessVersion" class="non-business-component"><span>Customer #: {{ customerNumber }}</span> </p>
<p *ngIf="!isBusinessVersion" class="non-business-component"><a href="/account">My Account</a></p>
<p *ngIf="!isBusinessVersion" class="non-business-component"><a href="/login">Log Out</a></p>

<p *ngIf="isBusinessVersion" class="business-component"><a href="/login">Log Out</a></p>